export const confirmDeleteQuestion = (
  <>
    This will permanently delete the question, and the answers you have
    collected for it so far will no longer be accessible.
    <br />
    <br />
    If you just want to remove the question for future respondents, you can hide
    the question instead.
  </>
);

export const confirmDeleteQuestionOption = (
  <>
    This will permanently delete this option and make inaccessible any answers
    that have selected this option.
    <br />
    <br />
    If you just want to remove this option for future respondents, you can hide
    the option instead.
  </>
);

export const confirmDeleteImageOption = (
  <>
    This will permanently delete this image option and make inaccessible any
    answers that have selected this option.
    <br />
    <br />
    If you just want to remove this option for future respondents, you can hide
    the option instead.
  </>
);

export const confirmRatingOptionChange = (
  <>
    Making a change to the rating scale for this question will make any previous
    answers inaccessible.
    <br />
    <br />
    If you want to preserve previous answers in your report, we recommend hiding
    this question and creating a new one with your changes.
  </>
);
